import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StandingOrderRoutingModule } from './standing-order-routing.module';
import { StandingOrderReviewedComponent } from './components/standing-order-reviewed/standing-order-reviewed.component';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { AgGridModule } from 'ag-grid-angular/src/aggrid.module';
import { DirectivesModule } from '../../directives/directives.module';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { FormsModule } from '@angular/forms';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { MyDatePickerModule } from 'mydatepicker';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import {StandingOrderService} from '../../services/standing-order.service';
import {EditReservationModule} from '../trip-reservations/edit-reservation/edit-reservation.module';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
  imports: [
    CommonModule,
    StandingOrderRoutingModule,
    AgGridModule.withComponents([BooleanCheckComponent]),
    DirectivesModule,
    Trip2ThemeModule,
    FormsModule,
    MyDateRangePickerModule,
    MyDatePickerModule,
    GridComponentsModule,
    EditReservationModule,
    NgMultiSelectDropDownModule
  ],
  declarations: [StandingOrderReviewedComponent],
  providers: [StandingOrderService, T2LoadingService]
})
export class StandingOrderModule { }



// WEBPACK FOOTER //
// ./src/app/pages/standing-order/standing-order.module.ts